<template>
  <div class="container">
  <ExternalQueryList
      endpoint="/api/v2/orders"
      :endpoint-filters="{associated_company_id: company.data.id}"
      :headlines="headlines"
      :can-update="() => true"
      @show="order => $router.push('/companies/'+company.data.id +'/orders/'+order.id)"
  >
    <template v-slot:default="{ row: order }">
      <td class="table__ellipsis">
        <router-link :to="'/companies/' + company.data.id + '/orders/' + order.id">
          HG{{ order.id }}
        </router-link>
      </td>

      <td class="table__ellipsis">
        {{ order.attributes.title }}

        <span v-if="order.attributes.company_id === company.data.id" class="label label-success">
          Own
        </span>

        <span v-if="order.attributes.other_payer_id === company.data.id" class="label label-info">
          Payer
        </span>
      </td>

      <td class="table__ellipsis">
        {{ order.attributes.purchase_order }}
      </td>

      <td class="table__ellipsis">
        {{ order.attributes.price_after_costs | price }}
      </td>

      <td class="table__ellipsis">
        {{ order.attributes.created_at | date }}
      </td>
    </template>
  </ExternalQueryList>
  </div>
</template>

<script>
import ExternalQueryList from '../../../../../components/Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  model: {
    prop: 'company',
  },

  props: {
    company: {
      required: true,
    }
  },

  computed: {
    headlines() {
      return [
        {width: 2, text: 'Number'},
        {width: 8, text: 'Title'},
        {width: 8, text: 'Purchase Order'},
        {width: 2, text: 'Price'},
        {width: 2, text: 'Date',},
      ]
    },
  }
}
</script>
